package chat.amp.tim

import androidx.compose.ui.graphics.Color

internal fun satLight(saturation: Float, lightness: Float) = Color.hsl(0F, saturation, lightness)

// Cherry Colors from IF digital https://development.if.digital/2026.cherry.tim/
internal val accentColor = Color(0xFFFFFFFF)

internal val md_theme_light_primary = Color(0xFF222743)
internal val md_theme_light_onPrimary = Color(0xFFFFFFFF)
internal val md_theme_light_primaryContainer = Color(0xFFF6F5F5)
internal val md_theme_light_onPrimaryContainer = Color(0xFF6F7070)
internal val md_theme_light_secondary = Color(0xFFB70031)
internal val md_theme_light_onSecondary = Color(0xFFFFFFFF)
internal val md_theme_light_secondaryContainer = Color(0xFFE50240)
internal val md_theme_light_onSecondaryContainer = Color(0xFFFFF8F8)
internal val md_theme_light_tertiary = Color(0xFFF6F5F5)
internal val md_theme_light_onTertiary = Color(0xFF848484)
internal val md_theme_light_tertiaryContainer = Color(0xFFF6F5F5)
internal val md_theme_light_onTertiaryContainer = Color(0xFF848484)
internal val md_theme_light_error = Color(0xFFBA1A1A)
internal val md_theme_light_errorContainer = Color(0xFFFFDAD6)
internal val md_theme_light_onError = Color(0xFFFFFFFF)
internal val md_theme_light_onErrorContainer = Color(0xFF93000A)
internal val md_theme_light_background = Color(0xFFFCF8F8)
internal val md_theme_light_onBackground = Color(0xFF1C1B1B)
internal val md_theme_light_surface = Color(0xFFF6F5F5)
internal val md_theme_light_onSurface = Color(0xFF1C1B1B)
internal val md_theme_light_surfaceVariant = Color(0xFFE0E3E3)
internal val md_theme_light_onSurfaceVariant = Color(0xFF444748)
internal val md_theme_light_outline = Color(0xFF747878)
internal val md_theme_light_inverseOnSurface = Color(0xFFF4F0EF)
internal val md_theme_light_inverseSurface = Color(0xFF313030)
internal val md_theme_light_inversePrimary = Color(0xFFC7C6C6)
internal val md_theme_light_surfaceTint = Color(0xFFDDD9D9)   // FIXME
internal val md_theme_light_outlineVariant = Color(0xFFC4C7C8)
internal val md_theme_light_scrim = Color(0xFF000000)


// Dark theme template (mostly used for lightness/saturation)
internal val md_theme_dark_primary = Color(0xFFFFFFFF)
internal val md_theme_dark_onPrimary = Color(0xFF2F3131)
internal val md_theme_dark_primaryContainer = Color(0xFFE3E2E2)
internal val md_theme_dark_onPrimaryContainer = Color(0xFF646465)
internal val md_theme_dark_secondary = Color(0xFFFFB3B5)
internal val md_theme_dark_onSecondary = Color(0xFF680018)
internal val md_theme_dark_secondaryContainer = Color(0xFFE50240)
internal val md_theme_dark_onSecondaryContainer = Color(0xFFFFF8F8)
internal val md_theme_dark_tertiary = Color(0xFFC6C6C6)
internal val md_theme_dark_onTertiary = Color(0xFF303030)
internal val md_theme_dark_tertiaryContainer = Color(0xFF000000)
internal val md_theme_dark_onTertiaryContainer = Color(0xFF757575)
internal val md_theme_dark_error = Color(0xFFFFB4AB)
internal val md_theme_dark_errorContainer = Color(0xFF93000A)
internal val md_theme_dark_onError = Color(0xFF690005)
internal val md_theme_dark_onErrorContainer = Color(0xFFFFDAD6)
internal val md_theme_dark_background = Color(0xFF141313)
internal val md_theme_dark_onBackground = Color(0xFFE5E2E1)
internal val md_theme_dark_surface = Color(0xFF141313)
internal val md_theme_dark_onSurface = Color(0xFFE5E2E1)
internal val md_theme_dark_surfaceVariant = Color(0xFF444748)
internal val md_theme_dark_onSurfaceVariant = Color(0xFFC4C7C8)
internal val md_theme_dark_outline = Color(0xFF8E9192)
internal val md_theme_dark_inverseOnSurface = Color(0xFF313030)
internal val md_theme_dark_inverseSurface = Color(0xFFE5E2E1)
internal val md_theme_dark_inversePrimary = Color(0xFF5E5E5F)
internal val md_theme_dark_surfaceTint = Color(0xFFC7C6C6)
internal val md_theme_dark_outlineVariant = Color(0xFF444748)
internal val md_theme_dark_scrim = Color(0xFF000000)
